import { Injectable } from '@angular/core';
import { Store, createSelector, select } from '@ngrx/store';
import { OnFieldChanged } from '../../../../../../shared/modules/configurable-form/models/on-field-changed';
import { getLocationPage, getSelectedBusinessLine, OrderBuilderState } from '../../../../../reducers/index';
import { LoadJobsiteStdLot } from '../../../actions/jobsite-actions/jobsite.actions';
import { divisionSalesArea } from '../../../../../../shared/utils/sales-area-by-division.method';
import { DIVISION_CODE } from '../../../../../../shared/constants/division-codes';
import { filter, take } from 'rxjs/operators';

export const locationWithBusinessLine = createSelector(
  getLocationPage,
  getSelectedBusinessLine,
  (location, businessLine) => {
    return {
      location,
      businessLine,
    };
  },
);

@Injectable()
export class PointOfDeliveryStdLotCommand implements OnFieldChanged {
  constructor(private store: Store<OrderBuilderState>) {}

  onFieldChanged(value: number): void {
    this.store
      .pipe(
        select(locationWithBusinessLine),
        filter(({ location }) => !!location.jobsite.jobsiteSalesArea.length),
        take(1),
      )
      .subscribe(({ location, businessLine }) => {
        if (!!value) {
          this.store.dispatch(
            new LoadJobsiteStdLot({
              jobsiteId: location.jobsite.selected.shipmentLocationId,
              productLineCode: businessLine.productTypeCode,
              salesAreaId: divisionSalesArea(location.jobsite.jobsiteSalesArea, DIVISION_CODE.CEMENT).salesArea
                .salesAreaId,
              pointOfDeliveryId: value,
            }),
          );
        }
      });
  }
}
